import React from 'react'
import Project from '../../components/projects/project'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/footer'
import { Helmet } from 'react-helmet'
export default function Projects() {
  return (
    <>
    <Helmet>
            <title>Projects — Gopal Goyal | AI & Full-Stack</title>
            <meta name='description'
            content='Projects by Gopal Goyal — agentic RAG systems, NLP models, MERN web apps, and machine learning projects.'/>
            <meta name='keywords' content='Gopal Goyal projects, Agentic RAG, NLP, MERN, machine learning, ReactJS, FastAPI'/>
        </Helmet>
      <Header/>
      <Project/>
      <Footer/>
    </>
  )
}
